module.exports = __webpack_public_path__ + "static/media/F-2-1.c5e6a1b2.webp";